import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/auth.store";
import { PartnerApi } from "../../../api/partner.api";
import { useTranslation } from "../../../hooks/useTranslation";
import UserSelectBranch from "../user/UserSelectBranch";

export default function OpportunityNewForm({ handleClose, items = null }) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [searchCompany, setSearchCompany] = useState(null);
  const [description, setDescription] = useState("");
  const [companyBranchId, setCompanyBranchId] = useState(null);
  const [companies, setCompanies] = useState(null);
  const navigate = useNavigate();

  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.getCurrentUser());

  const createOppotunity = (event) => {
    event.preventDefault();
    setDisabledSubmit(true);
    setError(null);
    const result = PartnerApi.opportunityAdd({
      token,
      description: description,
      company_branch_id: companyBranchId,
      company_id: selectedCompany,
      items: items?.map((item) => ({
        product_id: item.product_id,
        quantity: item.quantity,
        sn: item.sn,
      })),
    });
    result.then((result) => {
      setDisabledSubmit(false);

      if ("error" in result) {
        setError(result.error);
        return;
      }

      if ("opportunity_id" in result) {
        handleClose();
        return navigate("/prilezitost/" + result.opportunity_id);
      }
    });
    return false;
  };

  useEffect(()=>{
    if ("company_branch_id" in user.current_person && user.current_person.company_branch_id > 0) {
      setCompanyBranchId(user.current_person.company_branch_id);
    }
  }, [user, token]);

  useEffect(() => {
    if (token && searchCompany) {
      setError(null);
      PartnerApi.companySearch({ token, search: searchCompany }).then(
        (result) => {
          if ("error" in result) {
            setError(result.error);
            setCompanies([]);
            return;
          }

          setError(null);
          setCompanies(result);
        }
      );
    }
  }, [token, searchCompany]);

  return (
    <form onSubmit={(e) => createOppotunity(e)}>
      {error && <p className="alert alert-danger">{error}</p>}

      <UserSelectBranch
          user={user}
          companyBranchId={companyBranchId}
          setCompanyBranchId={setCompanyBranchId}
      />

      <div className="mb-10">
        <label htmlFor="formObchodniNazev" className="required form-label">
          {t("opportunities.dealName")}
        </label>
        <input
            type="text"
            id="formObchodniNazev"
            defaultValue={description}
            required={true}
            onChange={(e) => setDescription(e.target.value)}
            className="form-control form-control-solid"
            placeholder={t("opportunities.enterName")}
        />
      </div>

      {items && items.length > 0 && (
        <div className="mb-10">
          <label className=" form-label">{t("common.items")}</label>
          <table className="table table-bordered">
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.sku}</td>
                  <td>{item.sn}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mb-2">
        <label htmlFor="formKoncovyZakaznik" className="required form-label">
          {t("opportunities.endCustomer")}
        </label>
        <input
          type="text"
          id="formKoncovyZakaznik"
          defaultValue={searchCompany}
          required={true}
          onChange={(e) => setSearchCompany(e.target.value)}
          className="form-control form-control-solid"
          placeholder={t("opportunities.enterName")}
        />
      </div>

      <div className="overflow-auto mb-10" style={{maxHeight: "170px"}}>
        <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
          {companies?.map((company, company_key) => (
            <div className="menu-item" key={company_key}>
              <div
                onClick={() => setSelectedCompany(company.company_id)}
                className={
                  "cursor-pointer menu-link " +
                  (selectedCompany == company.company_id ? "active" : "")
                }
              >
                {selectedCompany == company.company_id && (
                  <span className="menu-icon" data-kt-element="icon">
                    <i className="ki-duotone ki-check fs-2">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                  </span>
                )}

                <span className="menu-title">
                  {company.name}
                  <br />
                  {t("opportunities.companyId")}: {company.ic}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button type="submit" disabled={disabledSubmit} className="btn btn-primary">
        {t("common.create")}
      </button>
    </form>
  );
}
